











import { Component, Prop, Vue } from 'vue-property-decorator';
import { ProductDto } from '@eurogast/hub-client-typescript';
import { ApiService } from '@/services/ApiService';
import { LinkUtil } from '@/services/LinkUtil';
import { DependencyService } from '@/services/DependencyService';

@Component
export default class PromoProducts extends Vue {
  @Prop({ required: true })
  public localSkus: string;

  public products: ProductDto[] = [];

  private productService = DependencyService.getProductService();

  public get skus() {
    let source = this.localSkus;
    if (source.startsWith('[')) {
      source = source.slice(1, -1);
    }
    return source.split(', ');
  }

  public mounted() {
    this.fetchProductDtos();
  }

  private async fetchProductDtos() {
    try {
      this.products = await this.productService.getProductBySkuBatch(this.skus, false);
    } catch (exception) {
      await ApiService.defaultErrorHandler(exception);
    }
  }

  public findImageUrl(product: ProductDto): string {
    return LinkUtil.getProductImageUrl(product);
  }

  public findDetailUrl(product): string {
    return LinkUtil.getProductDetailUrl(product.name, product.sku);
  }
}
